import './AccountMenu.scss';

import { CaretRight, SignOut } from '@phosphor-icons/react';
import { ButtonV2 } from '@travelwin/core';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { Link, useNavigate } from '../../../components/Link';
import { getUserDisplayName, useUser } from '../../../context/User';

const className = 'c-AccountMenu';

const AccountMenu = () => {
  const { t } = useTranslation();
  const { user, signOut } = useUser();
  const navigate = useNavigate();

  const signOutUser = () => {
    signOut().then(() => {
      navigate('/');
    });
  };

  return (
    <div className={className}>
      <div className={`${className}__header`}>
        <h2 className={`${className}__title`}>{getUserDisplayName(user)}</h2>
      </div>

      <div className={`${className}__nav`}>
        <MenuItem
          title={t('account_information.title', 'Account Information')}
          to={'/my-account/account-information'}
          activePaths={['/my-account']}
          dataTestId={'account-information-link'}
        />
        <MenuItem
          title={t('order_history.title', 'Order History')}
          to={'/my-account/order-history'}
          dataTestId={'order-history-link'}
        />
        <MenuItem
          title={t('marketing_preferences.title', 'Marketing Preferences')}
          to={'/my-account/marketing-preferences'}
          dataTestId={'marketing-preferences-link'}
        />
        <MenuItem
          title={t('account_settings.title', 'Account Settings')}
          to={'/my-account/account-settings'}
          dataTestId={'account-settings-link'}
        />
      </div>
      <div className={`${className}__divider`}></div>
      <div className={`${className}__logout`}>
        <ButtonV2
          data-testid="button-logout"
          variant="tertiary"
          intent="destructive-red"
          icons={{
            leading: <SignOut />,
          }}
          onClick={() => signOutUser()}
        >
          {t('my_account_menu.logout', 'Log Out')}
        </ButtonV2>
      </div>
    </div>
  );
};

interface MenuItemProps {
  title: string;
  to: string;
  activePaths?: string[];
  dataTestId?: string;
}

const MenuItem = ({ title, to, activePaths, dataTestId }: MenuItemProps) => {
  const location = useLocation();
  const isActive =
    to === location.pathname || activePaths?.includes(location.pathname);

  return (
    <Link
      className={classNames(`${className}__nav-item`, {
        [`${className}__nav-item--active`]: isActive,
      })}
      to={to}
      data-testid={dataTestId}
    >
      <div>{title}</div>
      <div className={`${className}__caret`}>
        <CaretRight size={16} weight="bold" />
      </div>
    </Link>
  );
};

export default AccountMenu;
